import React from 'react';
import Text from "../Text.js";
import S from '../Tree.css';
import { jsx as _jsx } from "react/jsx-runtime";
export default function DefaultSwitcherIcon(props) {
  const {
    isLeaf,
    expanded,
    data
  } = props;
  const nIsLeaf = data?.isLeaf != null ? data.isLeaf : isLeaf;
  if (nIsLeaf) {
    return null;
  }
  return /*#__PURE__*/_jsx(Text, {
    className: S.noHPad,
    icon: expanded ? 'fa fa-angle-down' : 'fa fa-angle-right'
  });
}